export default __webpack_public_path__ + "static/media/big_logo.a32c4c10.png";